module.exports = __webpack_public_path__ + "images/boatyard_logo_gasparilla.27383e3d6a40a6b87ac6fc10a0beec68.png";